import { Link2, ShieldAlert, ShieldCheck } from "lucide-react";
import { normVerdict, openGatedLink } from "@/lib/shield";
import { cn } from "@/lib/utils";

const STYLE = {
  safe: "border-bloq-mint/30 bg-bloq-mint/10 text-bloq-mint",
  warning: "border-amber-500/40 bg-amber-500/10 text-amber-400",
  blocked: "border-destructive/40 bg-destructive/10 text-destructive",
  unknown: "border-white/15 bg-white/5 text-white/80",
};

const domainOf = (url) => (url || "").replace(/^https?:\/\//i, "").split(/[/?#]/)[0];

// §9.5 verdict chips for `links[]` persisted on bios / BLOQ, channel & event descriptions / stories.
// Tap → the same pre-open interstitial as chat links.
export function LinkChips({ links, testid = "link-chips", className }) {
  if (!links?.length) return null;
  return (
    <div className={cn("flex flex-wrap gap-1.5", className)} data-testid={testid}>
      {links.map((l, i) => {
        const v = normVerdict(l.verdict);
        const Icon = v === "safe" ? ShieldCheck : v === "unknown" ? Link2 : ShieldAlert;
        return (
          <button
            key={`${l.url}-${i}`}
            type="button"
            onClick={(e) => { e.stopPropagation(); openGatedLink(l); }}
            title={l.label || l.url}
            className={cn("inline-flex max-w-full items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium transition-colors hover:brightness-110", STYLE[v])}
            data-testid={`${testid}-${i}`}
          >
            <Icon className="h-3 w-3 shrink-0" />
            <span className="truncate">{domainOf(l.url)}</span>
          </button>
        );
      })}
    </div>
  );
}
